const InvestmentsData = [
    {
        id:1,
        investmentItem : "Buy new mixer",
        cost: 900,
        correctCoqType: "P"
    },
    {
        id:2,
        investmentItem : "Use hand mixer",
        cost: 300,
        correctCoqType: "A"
    },
    {
        id:3,
        investmentItem : "Upgrade to white tablecloths",
        cost: 1200,
        correctCoqType: "O"
    },
    {
        id:4,
        investmentItem : "Use candles",
        cost: 5400,
        correctCoqType: "A"
    },
    {
        id:5,
        investmentItem : "Call the power company",
        cost: 9000,
        correctCoqType: "P"
    },
    {
        id:6,
        investmentItem : "Use a hose from across the street",
        cost: 2400,
        correctCoqType: "A"
    },
    {
        id:7,
        investmentItem : "Call the water company",
        cost: 10800,
        correctCoqType: "P"
    },
    {
        id:8,
        investmentItem : "Invest in new tables",
        cost: 9000,
        correctCoqType: "P"
    },
    {
        id:9,
        investmentItem : "Stick makeshift supports under the problem table legs",
        cost: 1800,
        correctCoqType: "A"
    },
    {
        id:10,
        investmentItem : "Have a kitchen staff check for spoiled vegetables",
        cost: 3600,
        correctCoqType: "A"
    },
    {
        id:11,
        investmentItem : "Purchase new refrigerator",
        cost: 15000,
        correctCoqType: "P"
    },
    {
        id:12,
        investmentItem : "Change bakery where desserts are prepared",
        cost: 15600,
        correctCoqType: "P"
    },
    {
        id:13,
        investmentItem : "Have wait staff check desserts before serving",
        cost: 2200,
        correctCoqType: "A"
    },
    {
        id:14,
        investmentItem : "Hire a pest control company to remediate the pest problem",
        cost: 16500,
        correctCoqType: "P"
    },
    {
        id:15,
        investmentItem : "Have staff regularly check for rodent intrusion",
        cost: 4200,
        correctCoqType: "A"
    },
    {
        id:16,
        investmentItem : "Buy new glassware",
        cost: 7800,
        correctCoqType: "P"
    },
    {
        id:17,
        investmentItem : "Have the staff use plastic cups",
        cost: 1800,
        correctCoqType: "A"
    },
    {
        id:18,
        investmentItem : "Have wait staff to double check all the checks before delivering to the table (overcharging/undercharging)",
        cost: 4200,
        correctCoqType: "A"
    },
    {
        id:19,
        investmentItem : "Upgrade to a computerized system",
        cost: 15000,
        correctCoqType: "P"
    },
    {
        id:20,
        investmentItem : "Hire a mascot to stand in front of the restaurant and bring customers in",
        cost: 600,
        correctCoqType: "O"
    },
    {
        id:21,
        investmentItem : "Call a plumber",
        cost: 5400,
        correctCoqType: "P"
    },
    {
        id:22,
        investmentItem : "Have staff use a plunger",
        cost: 600,
        correctCoqType: "A"
    },
    {
        id:23,
        investmentItem : "Buy new sign marquee outside restaurant",
        cost: 12000,
        correctCoqType: "O"
    },
    {
        id:24,
        investmentItem : "Have wait staff serve complimentary drinks for orders taking long",
        cost: 6000,
        correctCoqType: "A"
    },
    {
        id:25,
        investmentItem : "Hire more kitchen staff",
        cost: 15000,
        correctCoqType: "P"
    },
    {
        id:26,
        investmentItem : "Have staff check valet tickets and cars before returning the car to the owner",
        cost: 1920,
        correctCoqType: "A"
    },
    {
        id:27,
        investmentItem : "Hire a new valet company",
        cost: 8100,
        correctCoqType: "P"
    },
    {
        id:28,
        investmentItem : "Have staff dedicated to orders from the patio in the evenings",
        cost: 7500,
        correctCoqType: "A"
    },
    {
        id:29,
        investmentItem : "Come up with a downsized menu for the patio",
        cost: 2400,
        correctCoqType: "P"
    },
    {
        id:30,
        investmentItem : "Purchase a Venetian statue for the entrance of the restaurant",
        cost: 5400,
        correctCoqType: "O"
    },
    {
        id:31,
        investmentItem : "Instruct wait staff and [who typically sets the table] to inspect all glassware and flatware when setting the table",
        cost: 2400,
        correctCoqType: "A"
    },
    {
        id:32,
        investmentItem : "Get dishwasher repaired",
        cost: 9000,
        correctCoqType: "P"
    },
    {
        id:33,
        investmentItem : "Install a fountain on the patio",
        cost: 3600,
        correctCoqType: "O"
    },
    {
        id:34,
        investmentItem : "Hire a DJ to blast disco music",
        cost: 1800,
        correctCoqType: "O"
    },
    {
        id:35,
        investmentItem : "Hire new custodial crew",
        cost: 8100,
        correctCoqType: "P"
    },
    {
        id:36,
        investmentItem : "Have wait staff rotate sweeping up after closing",
        cost: 2400,
        correctCoqType: "A"
    },
    {
        id:37,
        investmentItem : "Redecorate the inside of the restaurant",
        cost: 6000,
        correctCoqType: "O"
    },
    {
        id:38,
        investmentItem : "Have bar staff re-trained",
        cost: 7200,
        correctCoqType: "P"
    },
    {
        id:39,
        investmentItem : "Have wait staff check drink orders before serving",
        cost: 1800,
        correctCoqType: "A"
    },
    {
        id:40,
        investmentItem : "Purchase new lounge furniture for the patio",
        cost: 3600,
        correctCoqType: "O"
    },

]
//DnD Data Only
const defaultDragItems = [
    {id:"DRAG_1",'title':'Oven Functioning',dropid:"DROP_1"},
    {id:"DRAG_2",'title':'Stove Functioning',dropid:"DROP_1"},
    {id:"DRAG_3",'title':'Refrigerator Functioning',dropid:"DROP_1"},
    {id:"DRAG_4",'title':'Point of Sale Systems Up-time',dropid:"DROP_1"},
    {id:"DRAG_5",'title':'Quality of Ingredients',dropid:"DROP_2"},
    {id:"DRAG_6",'title':'Consistency of Supply of Necessary Ingredients',dropid:"DROP_2"},
    {id:"DRAG_7",'title':'Quality of Dinnerware (Plates)',dropid:"DROP_2"},
    {id:"DRAG_8",'title':'Cleanliness of Silverware',dropid:"DROP_2"},
    {id:"DRAG_9",'title':'Efficiency of Food Prep Processes',dropid:"DROP_3"},
    {id:"DRAG_10",'title':'Quality of Recipes',dropid:"DROP_3"},
    {id:"DRAG_11",'title':'Process for Getting Food to Server',dropid:"DROP_3"},
    {id:"DRAG_12",'title':'Process for Server Delivering Food to Diner',dropid:"DROP_3"},
    {id:"DRAG_13",'title':'Training of Staff on Customer Service',dropid:"DROP_3"},
    {id:"DRAG_14",'title':'Performance Metrics',dropid:"DROP_4"},	
    {id:"DRAG_15",'title':'Customer Feedback Mechanisms',dropid:"DROP_4"},
    {id:"DRAG_16",'title':'Time from Order to Delivery',dropid:"DROP_4"},
    {id:"DRAG_17",'title':'Portion Control Guides',dropid:"DROP_4"},
    {id:"DRAG_18",'title':'Cleanliness of Kitchen',dropid:"DROP_5"},
    {id:"DRAG_19",'title':'Space within Dining Room',dropid:"DROP_5"},
    {id:"DRAG_20",'title':'Customer Turnout/Busyness of Restaurant',dropid:"DROP_5"},
    {id:"DRAG_21",'title':'Attentiveness of Server',dropid:"DROP_6"},
    {id:"DRAG_22",'title':'Consistency of Kitchen Staff',dropid:"DROP_6"},
    {id:"DRAG_23",'title':'Leadership from Chef',dropid:"DROP_6"},
    {id:"DRAG_24",'title':'Communication between front and back of house',dropid:"DROP_6"},
    {id:"DRAG_25",'title':'Customer doesn’t receive hot, quality food delivered to their table in a timely manner',dropid:"DROP_7"}
	
];

const defaultDropItems = [
    {id:"DROP_1",'title':'Machines',dragItems:[],color: "blue",infopopupMsg:"Covers all equipment and technology used in the restaurant, such as kitchen appliances and point-of-sale systems. Issues in this category typically involve malfunctioning or outdated equipment that needs updating or repair to improve efficiency and service quality."},
    {id:"DROP_2",'title':'Materials',dragItems:[], color: "green",infopopupMsg:"Relates to the supplies and ingredients used in the restaurant. This includes everything from food ingredients to table settings. Problems with materials often concern the quality, consistency, and availability of these items."},
    {id:"DROP_3",'title':'Methods',dragItems:[], color: "yellow",infopopupMsg:"Involves the procedures and workflows used in the restaurant's daily operations. This can include cooking techniques, service protocols, and cleaning routines. Efficient methods are crucial for maintaining high standards and ensuring customer satisfaction."},
    {id:"DROP_4",'title':'Measurements',dragItems:[],color: "blue",infopopupMsg:"Focuses on how the restaurant measures and evaluates its operations and services. This includes performance metrics and feedback mechanisms which are essential for quality control and continuous improvement."},
    {id:"DROP_5",'title':'Environment',dragItems:[],color: "green",infopopupMsg:"Encompasses both the physical setting of the restaurant and its ambiance. Issues here might relate to the layout, decor, noise levels, or general comfort. Enhancing the environment is key to providing a pleasant dining experience."},
    {id:"DROP_6",'title':'People',dragItems:[],color: "yellow",infopopupMsg:"Pertains to everyone involved in the restaurant from staff to customers. This category addresses staff management, training, and interaction with customers. Positive human relations are fundamental to the success of any restaurant."},
    {id:"DROP_7",'title':'Effect',dragItems:[],color: "red"}
];

export { InvestmentsData , defaultDragItems , defaultDropItems };